// extracted by mini-css-extract-plugin
export default {"btn":"SearchResultRow_btn__2fZQb","table-number-cell":"SearchResultRow_table-number-cell__QZ45I","tr":"SearchResultRow_tr__k2r+S"};